import { BerthCall } from '../../../types/ViewModel/BerthCall';
import { CargoOperation } from '../../../types/ViewModel/CargoOperation';
import { PortCall } from '../../../types/ViewModel/PortCall';
import { EventDate } from '../../../types/ViewModel/EventDate';
import { BerthCallBM } from '../../../types/BusinessModel/BerthCallBM';
import { BerthBM } from '../../../types/BusinessModel/BerthBM';
import { ReportLocationEnum } from '../../../enums/reportLocationEnum';
import { MoveActionMsg } from '../../../types/ViewModel/ActionMsg';
import { newCargoOperation, newCargoOperationFromCode } from './CargoOperationFactory';

const setBerthName = (berth: BerthBM): string | null => {
    if (berth) {
        if (berth.berthLongName) {
            return berth.berthLongName;
        }
        return berth.berthShortName;
    }
    return null;
};

const getBerthName = (berthName: string | null, berthNameFromEvent: string | null, berthId: number | null): string => {
    if (berthName) return berthName;
    return berthNameFromEvent ?? '??? (berth-id: ' + (berthId ? berthId.toString() : 'N/A') + ')';
};

export const newBerthCall = (berthCall: BerthCallBM, parentPortCall: PortCall): BerthCall | null => {
    const cargoOperationArray: CargoOperation[] = [];
    if (berthCall && berthCall.berthOperations && berthCall.berthOperations.length > 0) {
        berthCall.berthOperations.map((berthOperation) => {
            if (!berthOperation.isNonCargo) {
                const newCargoOperation1 = newCargoOperation(berthOperation);
                if (newCargoOperation1) {
                    cargoOperationArray.push(newCargoOperation1);
                }
            }
        });
    }

    if (berthCall) {
        const voyageNumber = berthCall.voyageNumber + (berthCall.turnaroundVoyageNumber ? '/' + berthCall.turnaroundVoyageNumber : '');
        const newBerthCall1 = new BerthCall(
            berthCall.berthCallId,
            cargoOperationArray,
            berthCall.berth ? berthCall.berth.berthId : 0,
            voyageNumber,
            setBerthName(berthCall.berth),
            new EventDate(berthCall.arrivalDate.plannedDateTimeUTC, null, berthCall.arrivalDate.actualDateTimeUTC, null),
            new EventDate(berthCall.departureDate.plannedDateTimeUTC, null, berthCall.departureDate.actualDateTimeUTC, null),
            parentPortCall,
            '',
            false,
            false,
            false,
            false,
            false,
            false,
            null,
            null,
            null,
            ReportLocationEnum.Port,
            berthCall.manualBerthSequenceNumber,
            null,
            null,
            null,
            null,
            null
        );
        newBerthCall1.cargoOperationArray.map((c) => {
            c.berthCall = newBerthCall1;
        });
        return newBerthCall1;
    }
    return null;
};

export const newBerthCallFromCode = (berthCall: BerthCall): BerthCall => {
    const cargoOpArray: CargoOperation[] = [];
    berthCall.cargoOperationArray.forEach((co) => {
        const newCo = newCargoOperationFromCode(co, berthCall);
        if (newCo) {
            cargoOpArray.push(newCo);
        }
    });
    const bc = new BerthCall(
        berthCall.berthCallId,
        cargoOpArray,
        berthCall.berthId,
        berthCall.voyageNumber,
        berthCall.name,
        berthCall.arrivalDate,
        berthCall.departureDate,
        berthCall.portCall,
        berthCall.nodeStatus,
        berthCall.isDeleted,
        berthCall.addedDeletedBerthCall,
        berthCall.isLocked,
        berthCall.isMoved,
        berthCall.isMovedTo,
        berthCall.isSelected,
        berthCall.deletedIconTooltipText,
        berthCall.moveToBerthCallId,
        berthCall.aolDate,
        berthCall.reportLocation,
        berthCall.manualBerthSequenceNumber,
        berthCall.imosPortFunction,
        berthCall.portClusterInitialPortId,
        berthCall.portClusterInitialPortName,
        berthCall.delayInputWarningText,
        berthCall.firstTimeInPortCall
    );
    bc.actionMsg = new MoveActionMsg(
        berthCall.actionMsg.displayMoveIcon,
        berthCall.actionMsg.message,
        berthCall.actionMsg.doAction,
        berthCall.actionMsg.toolTipText,
        berthCall.actionMsg.moveToNodeText,
        berthCall.actionMsg.id
    );
    return bc;
};

export const newBerthCallFromCodeExcludeMovedAndDeleted = (berthCall: BerthCall): BerthCall => {
    const cargoOpArray: CargoOperation[] = [];
    berthCall.cargoOperationArray.forEach((co) => {
        if (!co.isDeleted && !co.isMoved) {
            const newCo = newCargoOperationFromCode(co, berthCall);
            if (newCo) {
                cargoOpArray.push(newCo);
            }
        }
    });
    const bc = new BerthCall(
        berthCall.berthCallId,
        cargoOpArray,
        berthCall.berthId,
        berthCall.voyageNumber,
        berthCall.name,
        berthCall.arrivalDate,
        berthCall.departureDate,
        berthCall.portCall,
        berthCall.nodeStatus,
        berthCall.isDeleted,
        berthCall.addedDeletedBerthCall,
        berthCall.isLocked,
        berthCall.isMoved,
        berthCall.isMovedTo,
        berthCall.isSelected,
        berthCall.deletedIconTooltipText,
        berthCall.moveToBerthCallId,
        berthCall.aolDate,
        berthCall.reportLocation,
        berthCall.manualBerthSequenceNumber,
        berthCall.imosPortFunction,
        berthCall.portClusterInitialPortId,
        berthCall.portClusterInitialPortName,
        berthCall.delayInputWarningText,
        berthCall.firstTimeInPortCall
    );
    bc.actionMsg = new MoveActionMsg(
        berthCall.actionMsg.displayMoveIcon,
        berthCall.actionMsg.message,
        berthCall.actionMsg.doAction,
        berthCall.actionMsg.toolTipText,
        berthCall.actionMsg.moveToNodeText,
        berthCall.actionMsg.id
    );
    return bc;
};

export const newDeletedBerthCallFromCode = (
    berthCallId: number | null,
    berthId: number | null,
    portName: string | null,
    berthName: string | null,
    portCall: PortCall | null,
    voyageNumber: string | null,
    berthNameFromEvent: string | null
): BerthCall => {
    if (!voyageNumber) {
        if (portCall && portCall.voyageNumber1) {
            voyageNumber = portCall.voyageNumber1;
        } else {
            voyageNumber = '???';
        }
    }
    return new BerthCall(
        berthCallId,
        [],
        berthId,
        voyageNumber,
        getBerthName(berthName, berthNameFromEvent, berthId),
        portCall ? portCall.arrivalDate : null,
        portCall ? portCall.departureDate : null,
        portCall,
        '',
        true,
        false,
        false,
        false,
        false,
        false,
        null,
        null,
        null,
        ReportLocationEnum.Port,
        null,
        null,
        null,
        null,
        null,
        null
    );
};
